import template from './refineDirection.html';

function refineDirection() {
  return {
    template,
    restrict: 'E',
    scope: {
      default: '@',
      filterSet: '='
    },
    controller: ['$scope', '$location', ($scope, $location) => {
      const loc = $location.search();
      const initDirection = loc.sd ? loc.sd : $scope.default;
      $scope.direction = $scope.filterSet.getFilter('direction', initDirection);

      if ($scope.filterSet.filters.taskSort) {
        $scope.taskSort = $scope.filterSet.getFilter('taskSort');
      }

      $scope.update = (newDirection) => {
        $scope.direction.changeValue(newDirection);
      };
    }]
  };
}

const directiveArr = [
  refineDirection
];

export default function (ngModule) {
  ngModule.directive('refineDirection', directiveArr);
}
